// "More ideas" carousel on project articles (sections/article-related-ideas.liquid).
// The track scrolls natively (swipe / trackpad); the arrows page through it on larger screens.
if (!customElements.get('related-ideas')) {
  customElements.define('related-ideas', class RelatedIdeas extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-related-track]');
      this.prev = this.querySelector('[data-related-prev]');
      this.next = this.querySelector('[data-related-next]');
      if (!this.track || !this.prev || !this.next) return;

      this.update = this.update.bind(this);
      this.prev.addEventListener('click', () => this.page(-1));
      this.next.addEventListener('click', () => this.page(1));
      this.track.addEventListener('scroll', this.update, { passive: true });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.track);
      } else {
        window.addEventListener('resize', this.update);
      }
      this.update();
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      window.removeEventListener('resize', this.update);
    }

    page(direction) {
      const item = this.track.querySelector('.related-ideas__item');
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = item ? item.offsetWidth + gap : this.track.clientWidth;
      const perPage = Math.max(1, Math.floor((this.track.clientWidth + gap) / step));
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({ left: direction * step * perPage, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    update() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const scrollable = maxScroll > 2;
      this.prev.hidden = !scrollable;
      this.next.hidden = !scrollable;
      this.prev.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= maxScroll - 2;
    }
  });
}
